var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarefullyRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1653_33924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4 30.7C18.8 30.7 18.2 30.6 17.7 30.6H5.3C4.8 30.6 4.5 30.3 4.5 29.8C4.5 29.3 4.8 29 5.3 29H13.6C12.5 28.3 11.5 27.4 10.7 26.4H5.3C4.8 26.4 4.5 26.1 4.5 25.6C4.5 25.1 4.8 24.8 5.3 24.8H9.7C8.8 23.2 8.4 21.4 8.4 19.5C8.4 13.4 13.4 8.5 19.5 8.5C21.3 8.5 22.9 8.9 24.4 9.7V5.3C24.4 4 23.4 3 22.1 3H18.4V5.3C18.4 6.6 17.4 7.6 16.1 7.6H7.9C6.6 7.6 5.6 6.6 5.6 5.3V3H2.3C1 3 0 4 0 5.3V32.6C0 33.9 1 34.9 2.3 34.9H22.1C23.4 34.9 24.4 33.9 24.4 32.6V29.6C22.9 30.3 21.2 30.7 19.4 30.7Z",
    fill: "#204E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5999 24.8C28.5999 23.3 29.0999 21.5 29.0999 19.6C29.0999 14.3 24.7999 10 19.4999 10C14.1999 10 9.8999 14.3 9.8999 19.6C9.8999 24.9 14.1999 29.2 19.4999 29.2C21.3999 29.2 23.1999 28.6 24.6999 27.7C25.3999 28.4 26.7999 29.3 27.9999 28.1C29.2999 26.6 28.1999 25.3 27.5999 24.8ZM19.3999 27.5C14.9999 27.5 11.4999 24 11.4999 19.6C11.4999 15.2 15.0999 11.7 19.3999 11.7C23.7999 11.7 27.2999 15.2 27.2999 19.6C27.3999 24 23.7999 27.5 19.3999 27.5Z",
    fill: "#23B5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1999 6.1H15.8999C16.2999 6.1 16.6999 5.7 16.6999 5.4V3H15.0999C15.0999 1.3 13.6999 0 11.9999 0C10.2999 0 8.9999 1.4 8.9999 3H7.3999V5.3C7.3999 5.8 7.7999 6.1 8.1999 6.1Z",
    fill: "#204E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2998 29.6C27.8998 30.3 31.0998 33.8 31.7998 34.6C32.4998 35.4 34.0998 34.8 34.5998 34.2C35.0998 33.5 35.2998 32.4 34.5998 31.7C33.8998 31 29.4998 27.5 29.4998 27.5C29.3998 28.6 27.8998 29.6 27.2998 29.6Z",
    fill: "#23B5E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1653_33924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarefullyRead);
export default __webpack_public_path__ + "static/media/carefullyRead.dbf120fc2a003fd989a6ddea18431076.svg";
export { ForwardRef as ReactComponent };